/* tslint:disable */

export enum GuidelineElementSection {
  Default = 1,
  InText = 2,
}
